/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllInvInqLookups: {
        $xmlns: 'http://dobs.pa.gov/sc/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllInvInqLookupsResponse.Types.SC_LU_InvInqType',
      'GetAllInvInqLookupsResponse.Statuses.SC_LU_InvInqStatus',
      'GetAllInvInqLookupsResponse.Categories.SC_LU_InvInqCategory',
      'GetAllInvInqLookupsResponse.RelatedCaseTypes.SC_LU_InqInvRelatedCaseType',
      'GetAllInvInqLookupsResponse.Offices.SC_LU_ExamInvInqOffice'
    ],
    blueprint: {
      invInqTypes: [
        '$..SC_LU_InvInqType',
        {
          id: '$.ID',
          type: '$.Type'
        }
      ],
      invInqStatuses: [
        '$..SC_LU_InvInqStatus',
        {
          id: '$.ID',
          status: '$.Status'
        }
      ],
      invInqCategories: [
        '$..SC_LU_InvInqCategory',
        {
          id: '$.ID',
          category: '$.Category'
        }
      ],
      invInqRelatedCaseTypes: [
        '$..SC_LU_InqInvRelatedCaseType',
        {
          id: '$.ID',
          relatedCaseType: '$.Type'
        }
      ],
      invInqOffices: [
        '$..SC_LU_ExamInvInqOffice',
        {
          id: '$.ID',
          office: '$.Office'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
